var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "cf-node-properties__panel",
      class: {
        "cf-node-properties__panel--open": _vm.showContent,
        "cf-node-properties__panel--error": !_vm.route.isValid
      }
    },
    [
      _c(
        "div",
        {
          staticClass: "cf-node-properties__panel-heading",
          on: {
            click: function($event) {
              _vm.showContent = !_vm.showContent
            }
          }
        },
        [
          _c("div", [
            _vm.openOptions
              ? _c("span", { staticClass: "p-r-5" }, [
                  _c("i", {
                    staticClass: "fa fa-angle-right",
                    class: { "fa-rotate-90": _vm.showContent },
                    attrs: { "aria-hidden": "true" }
                  })
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.hasFilter
              ? _c("i", {
                  staticClass: "fa fa-filter p-r-5",
                  class: _vm.filterClass
                })
              : _vm._e(),
            _vm._v(" "),
            _c("span", { staticClass: "m-r-10" }, [
              _vm.route.weight
                ? _c("strong", { staticClass: "m-r-5" }, [
                    _vm._v(_vm._s(_vm.weightInfo))
                  ])
                : _vm._e(),
              _vm._v(" " + _vm._s(_vm.routeName))
            ]),
            _vm._v(" "),
            _c("span", [
              _vm.targetNode.nodeOptions.icon
                ? _c("i", {
                    staticClass: "m-r-5",
                    class: _vm.targetNode.nodeOptions.icon,
                    attrs: { "aria-hidden": "true" }
                  })
                : _vm._e(),
              _vm._v("\n        " + _vm._s(_vm.displayName) + "\n      ")
            ]),
            _vm._v(" "),
            _vm.addRoutes
              ? _c(
                  "button",
                  {
                    staticClass: "btn btn-function m-l-10",
                    on: {
                      click: function($event) {
                        $event.stopPropagation()
                        $event.preventDefault()
                        return _vm.addNodeToRoute.apply(null, arguments)
                      }
                    }
                  },
                  [_c("i", { staticClass: "fa fa-plus" })]
                )
              : _vm._e()
          ]),
          _vm._v(" "),
          _vm.sortable ? _c("SortableDragButton") : _vm._e()
        ],
        1
      ),
      _vm._v(" "),
      _vm.openOptions
        ? _c(
            "collapse",
            {
              model: {
                value: _vm.showContent,
                callback: function($$v) {
                  _vm.showContent = $$v
                },
                expression: "showContent"
              }
            },
            [
              _c(
                "div",
                {
                  ref: "panelBody",
                  staticClass: "cf-node-properties__panel-body",
                  attrs: { tabindex: "-1" }
                },
                [_vm._t("default")],
                2
              )
            ]
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }